var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',{attrs:{"title":"No slots found"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"p-8"},[_c('p',[_vm._v(" No scheduled slots found. To continue posting, "),_c('button',{staticClass:"text-main-color-100",on:{"click":_vm.goToSchedule}},[_vm._v("please create some slots")]),_vm._v(". ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }